export default __webpack_public_path__ + "static/media/sopPlayIcon.cb0e14b5.svg";